import styled from '@emotion/styled'

export const EditableCell = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const EditableInput = styled.input`
  width: 90px;
  height: 30px;
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  border-radius: 6px;
  padding: 0 8px;
  font-size: 13px;
  color: ${(props: any) => props.theme.colors.text};
  background-color: transparent;
  outline: none;

  &:focus {
    border-color: ${(props: any) => props.theme.colors.primary};
  }
`

export const EditableSaveButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: none;
  background-color: ${(props: any) => props.theme.colors.primary};
  color: ${(props: any) => props.theme.colors.white};
  cursor: pointer;
  font-size: 12px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const RowThumb = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  object-fit: cover;
`

export const RowThumbPlaceholder = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props: any) => props.theme.colors.primaryLight};
  color: ${(props: any) => props.theme.colors.placeholder || '#94a3b8'};
  font-size: 10px;
`

export const RowEdit = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  cursor: pointer;

  svg {
    width: 14px;
    height: 14px;
  }

  &:hover {
    opacity: 0.7;
  }
`

export const PickerWrapper = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  border-radius: 12px;
  background-color: ${(props: any) => props.theme.colors.white};
  padding: 16px;
  margin-bottom: 24px;
`

export const PickerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const PickerLabel = styled.p`
  font-size: 15px;
  font-weight: 600;
  color: ${(props: any) => props.theme.colors.text};
`

export const PickerSearchInput = styled.input`
  width: 260px;
  height: 38px;
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  border-radius: 8px;
  outline: none;
  background-color: transparent;
  color: ${(props: any) => props.theme.colors.text};
  padding: 0 12px;
  font-size: 14px;

  &:focus {
    border-color: ${(props: any) => props.theme.colors.primary};
  }

  &::placeholder {
    color: ${(props: any) => props.theme.colors.placeholder || '#94a3b8'};
  }
`

export const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
  max-height: 320px;
  overflow-y: auto;
  padding-right: 4px;
`

export const CategoryCard = styled.button<{ $selected?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 2px solid
    ${(props: any) => (props.$selected ? props.theme.colors.primary : 'transparent')};
  background-color: ${(props: any) => props.theme.colors.primaryLight};
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  text-align: left;

  &:hover {
    border-color: ${(props: any) => props.theme.colors.primary};
  }

  &:disabled {
    cursor: not-allowed;
  }
`

export const CategoryCardName = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${(props: any) => props.theme.colors.text};
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const CategoryCardCount = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: ${(props: any) => props.theme.colors.primary};
`

export const SelectedCategoryBar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 8px;
  background-color: ${(props: any) => props.theme.colors.primaryLight};
  margin-bottom: 16px;
`

export const SelectedCategoryText = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${(props: any) => props.theme.colors.text};
  flex: 1;
`

export const ChangeCategoryLink = styled.button`
  background: none;
  border: none;
  color: ${(props: any) => props.theme.colors.primary};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
`

export const ManagePanel = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  border-radius: 12px;
  background-color: ${(props: any) => props.theme.colors.white};
  padding: 16px;
  margin-bottom: 24px;
`

export const ManagePanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
`

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  border: none;
  background-color: ${(props: any) => props.theme.colors.primary};
  color: ${(props: any) => props.theme.colors.white};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  svg {
    width: 14px;
    height: 14px;
  }
`

export const ChipList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`

export const Chip = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 20px;
  border: 2px solid
    ${(props: any) =>
      props.$active ? props.theme.colors.primary : props.theme.colors.borderColor};
  background-color: ${(props: any) =>
    props.$active ? props.theme.colors.primaryLight : 'transparent'};
  color: ${(props: any) => props.theme.colors.text};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
`

export const ChipImage = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
`

export const ChipEdit = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  cursor: pointer;

  svg {
    width: 13px;
    height: 13px;
  }

  &:hover {
    opacity: 0.7;
  }
`

export const HiddenFileInput = styled.input`
  display: none;
`

export const ChipRemove = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;

  svg {
    width: 12px;
    height: 12px;
  }

  &:hover {
    opacity: 0.7;
  }
`

export const EmptyState = styled.p`
  font-size: 13px;
  color: ${(props: any) => props.theme.colors.placeholder || '#94a3b8'};
`

export const CheckBadge = styled.span`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: ${(props: any) => props.theme.colors.primary};
  color: ${(props: any) => props.theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  line-height: 1;
`

export const PickerFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid ${(props: any) => props.theme.colors.borderColor};
`

export const SubmitButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 18px;
  border-radius: 8px;
  border: none;
  background-color: ${(props: any) => props.theme.colors.primary};
  color: ${(props: any) => props.theme.colors.white};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const AddServiceFormWrapper = styled.div`
  padding: 4px;
`

export const AddServiceFormTitle = styled.p`
  font-size: 15px;
  font-weight: 600;
  color: ${(props: any) => props.theme.colors.text};
  margin-bottom: 4px;
`

export const AddServiceFormMeta = styled.p`
  font-size: 12px;
  color: ${(props: any) => props.theme.colors.placeholder || '#94a3b8'};
  margin-bottom: 16px;
`

export const AddServiceFormRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 12px;

  @media (max-width: 640px) {
    flex-direction: column;
  }
`

export const AddServiceFormField = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const AddServiceFormLabel = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: ${(props: any) => props.theme.colors.text};
`

export const AddServiceFormError = styled.p`
  font-size: 12px;
  color: #e5484d;
  margin-bottom: 12px;
`

export const AddServiceFormActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 4px;
`

export const VariantBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background-color: ${(props: any) => props.theme.colors.primary};
  color: ${(props: any) => props.theme.colors.white};
  font-size: 11px;
  font-weight: 600;
  margin-left: 8px;
`

export const ServiceNameCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const ServiceNameLabel = styled.span`
  font-size: 13px;
  color: ${(props: any) => props.theme.colors.text};
  display: flex;
  align-items: center;
`

export const ServiceIdLabel = styled.span`
  font-size: 11px;
  color: ${(props: any) => props.theme.colors.placeholder || '#94a3b8'};
`

export const IncompleteTag = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  background-color: rgba(229, 72, 77, 0.12);
  color: #e5484d;
  font-size: 11px;
  font-weight: 600;
`

export const Spinner = styled.span`
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: picker-spin 0.7s linear infinite;

  @keyframes picker-spin {
    to {
      transform: rotate(360deg);
    }
  }
`
